import React from "react";
import { Link } from "react-router";

function Button({
  children,
  style = "primary",
  className,
  onClick,
  link,
  target,
  role,
  tabIndex = undefined,
  ...props
}: {
  children: React.ReactNode;
  style?: string;
  className?: string;
  onClick?: (e: any) => void;
  link?: string | null;
  target?: string;
  role?: string;
  tabIndex?: number;
  [key: string]: any;
}) {
  return (
    <>
      {link ? (
        <Link
          className={`block ${styles[style]} ${className}`}
          to={link}
          onClick={onClick}
          target={target ? "_blank" : undefined}
          tabIndex={tabIndex}
          {...props}
        >
          {typeof children === "string" ? <span>{children}</span> : children}
        </Link>
      ) : (
        <button
          className={`${styles[style]} ${className}`}
          onClick={onClick}
          role={role}
          tabIndex={tabIndex}
          {...props}
        >
          {typeof children === "string" ? <span>{children}</span> : children}
        </button>
      )}
    </>
  );
}

export default Button;

const styles = {
  primary:
    "bg-surface-primary hover:bg-surface-primary-hover active:bg-surface-primary-active text-text-inverted p-2 px-5 rounded-full block shadow-sm hover:shadow-md hover:cursor-pointer",
  secondary:
    "bg-surface-secondary hover:bg-surface-secondary-hover active:bg-surface-secondary-active text-text-inverted p-2 px-5 rounded-full block shadow-sm hover:shadow-md hover:cursor-pointer",
  tertiary:
    "bg-surface-tertiary hover:bg-surface-tertiary-hover active:bg-surface-tertiary-active text-text-base p-2 px-5 rounded-full block shadow-sm hover:shadow-md hover:cursor-pointer",
};
